import Model from './Model'
import moment from "moment";
import {uuid} from "../utils";

export default class Fs extends Model {
    static async find(filesystemId) {
        const data = this.make(await Http.get(route('api.v2.filesystem', filesystemId)))
        data.nodes = Fs.buildNodes(data.nodes, data);
        data.isRoot = true;
        return data;
    }

    static thumbnailKeys = [];

    static getThumbnailKey(fsId, fId) {
        if (typeof Fs.thumbnailKeys[fsId + '|' + fId] === 'undefined') {
            Fs.thumbnailKeys[fsId + '|' + fId] = 0;
        }
        return Fs.thumbnailKeys[fsId + '|' + fId];
    }

    static incrementThumbnailKey(fsId, fId) {
        if (typeof Fs.thumbnailKeys[fsId + '|' + fId] === 'undefined') {
            Fs.thumbnailKeys[fsId + '|' + fId] = 0;
        }
        Fs.thumbnailKeys[fsId + '|' + fId]++;
    }

    static async findNode(filesystemId, nodeId) {
        const data = this.make(await Http.get(route('api.v2.filesystem.node', [filesystemId, nodeId])))
        data.nodes = Fs.buildNodes(data.nodes);
        return data;
    }

    search(match, parent = null) {
        const query = match.toLowerCase().split(" ").filter((i) => i !== '')
        let searchNodes = (nodes, search, r) => {
            for (let x in nodes) {
                if (r.length > 99) {
                    return;
                }
                let i = nodes[x]
                if (i.tokens) {
                    let contains = query.every((token) => {
                        return i.tokens.includes(token);
                    })
                    if (contains) {
                        r.push(i)
                    }
                }
                if (i.nodes) {
                    searchNodes(i.nodes, search, r)
                }
            }
        }
        let r = [];
        searchNodes(parent ? parent.nodes : this.nodes, query, r);
        Fs.orderNodes(r, this.prefs)
        return r;
    }

    reorderNodes(prefs) {
        this.prefs = prefs;
        Fs.orderNodes(this.nodes, this.prefs);
    }

    async requestNodesAsZip(id, nodes) {
        const config = {nodes: nodes.map((i) => i.id)}
        await Http.post(route('api.v2.filesystem.zip.request', [this.id, id]), config).catch(error => {
            if (error.status !== 200) {
                throw new Error(error.response.data.message)
            }
        });
    }

    async abortZip(id) {
        await Http.delete(route('api.v2.filesystem.zip.delete', [this.id, id]));
    }

    static orderNodes(nodes, prefs) {
        nodes.groups = [];
        nodes.forEach((n) => {
            if (!n.selectedGroups) n.selectedGroups = []
        })
        if (prefs.groupBy === 'tags') {
            nodes.forEach((node) => {
                if (node.tags && node.tags.length) {
                    node.tags.forEach((tag) => {
                        let group = {
                            'title': tag, 'tags': [tag], 'nodes': [], 'id': uuid()
                        }
                        let groupData = nodes.groups.find((i) => i.title === group.title)
                        if (!groupData) {
                            groupData = group
                            nodes.groups.push(groupData)
                        }
                        groupData.nodes.push({node: node})
                    })
                } else {
                    let group = {
                        'title': 'Un-Tagged', 'tags': [], 'nodes': [], 'id': uuid()
                    }
                    let groupData = nodes.groups.find((i) => i.title === group.title)
                    if (!groupData) {
                        groupData = group
                        nodes.groups.push(groupData)
                    }
                    groupData.nodes.push({node: node})
                }
            })
            nodes.groups.sort((a, b) => {
                return (a.title.localeCompare(b.title))
            })
            const unknown = nodes.groups.find((i) => i.title === '')
            if (unknown) {
                nodes.groups.splice(nodes.groups.indexOf(unknown), 1)
                nodes.groups.push(unknown)
            }
        } else if (prefs.groupBy === 'created') {
            nodes.forEach((node) => {
                let group = {nodes: [], 'id': uuid()}
                if (node.createdAt.isSame(moment(), "day")) {
                    group.title = 'Created today'
                    group.order = 1
                } else if (node.createdAt.isSame(moment().subtract(1, 'day'), 'day')) {
                    group.title = 'Created yesterday'
                    group.order = 2
                } else if (Math.abs(node.createdAt.diff(moment().subtract(7, 'day'), 'day')) < 8) {
                    group.title = 'Created last week (7 days)'
                    group.order = 3
                } else if (Math.abs(node.createdAt.diff(moment().subtract(31, 'day'), 'day')) < 31) {
                    group.title = 'Created last month (30 days)'
                    group.order = 4
                } else {
                    group.title = 'Created more than 30 days ago'
                    group.order = 5
                }
                let groupData = nodes.groups.find((i) => i.title === group.title)
                if (!groupData) {
                    groupData = group
                    nodes.groups.push(groupData)
                }
                groupData.nodes.push({node: node})
            })
            nodes.groups.sort((a, b) => a.order - b.order)
        } else if (prefs.groupBy === 'createdBy') {
            nodes.forEach((node) => {
                let group = {
                    'title': node.createdBy, 'nodes': [], 'id': uuid()
                }
                let groupData = nodes.groups.find((i) => i.title === node.createdBy)
                if (!groupData) {
                    groupData = group
                    nodes.groups.push(groupData)
                }
                groupData.nodes.push({node: node})
            })
            nodes.groups.sort((a, b) => {
                return (a.title.localeCompare(b.title))
            })
        } else if (prefs.groupBy === 'updated') {
            nodes.forEach((node) => {
                let group = {nodes: [], 'id': uuid()}
                if ((node.lastUpdatedAt ? node.lastUpdatedAt : node.createdAt).isSame(moment(), "day")) {
                    group.title = 'Updated today'
                    group.order = 1
                } else if ((node.lastUpdatedAt ? node.lastUpdatedAt : node.createdAt).isSame(moment().subtract(1, 'day'), 'day')) {
                    group.title = 'Updated yesterday'
                    group.order = 2
                } else if (Math.abs((node.lastUpdatedAt ? node.lastUpdatedAt : node.createdAt).diff(moment().subtract(7, 'day'), 'day')) < 8) {
                    group.title = 'Updated last week (7 days)'
                    group.order = 3
                } else if (Math.abs((node.lastUpdatedAt ? node.lastUpdatedAt : node.createdAt).diff(moment().subtract(31, 'day'), 'day')) < 31) {
                    group.title = 'Updated last month (30 days)'
                    group.order = 4
                } else {
                    group.title = 'Updated more than 30 days ago'
                    group.order = 5
                }
                let groupData = nodes.groups.find((i) => i.title === group.title)
                if (!groupData) {
                    groupData = group
                    nodes.groups.push(groupData)
                }
                groupData.nodes.push({node: node})
            })
            nodes.groups.sort((a, b) => a.order - b.order)
        } else if (prefs.groupBy === 'updatedBy') {
            nodes.forEach((node) => {
                let group = {
                    'title': (node.lastUpdatedBy ? node.lastUpdatedBy : node.createdBy), 'nodes': [], 'id': uuid()
                }
                let groupData = nodes.groups.find((i) => i.title === (node.lastUpdatedBy ? node.lastUpdatedBy : node.createdBy))
                if (!groupData) {
                    groupData = group
                    nodes.groups.push(groupData)
                }
                groupData.nodes.push({node: node})
            })
            nodes.groups.sort((a, b) => {
                return (a.title.localeCompare(b.title))
            })
        } else {
            nodes.groups.push({
                'title': '', 'id': uuid(), 'nodes': nodes.map((node) => {
                    return {node: node};
                })
            })
        }
        let nodeOrder = 0;
        let previousNode = false;
        nodes.groups.forEach((nodeGroup, groupIndex) => {
            nodeGroup.nodes.sort((a, b) => {
                a = a.node
                b = b.node
                let ret = 0;
                if (prefs.foldersOnTop) {
                    ret = ((a.isDirectoryType === false) - (b.isDirectoryType === false))
                }
                if (prefs.sortBy === 'name') {
                    return ret || a.name.localeCompare(b.name)
                } else if (prefs.sortBy === 'modified') {
                    let amoment = a.createdAt
                    if (a.lastUpdatedAt) {
                        amoment = a.lastUpdatedAt
                    }
                    let bmoment = b.createdAt
                    if (b.lastUpdatedAt) {
                        bmoment = b.lastUpdatedAt
                    }
                    return ret || bmoment.valueOf() - amoment.valueOf()
                } else if (prefs.sortBy === 'created') {
                    let amoment = a.createdAt
                    let bmoment = b.createdAt
                    return ret || bmoment.valueOf() - amoment.valueOf()
                }
            });
            nodeGroup.nodes.forEach((i, key) => {
                i.groupIndex = groupIndex
                i.nodeGroup = nodeGroup
                if (previousNode) {
                    previousNode.nextNode = i
                    i.previousNode = previousNode
                }
                i.id = groupIndex + '-' + i.node.id
                previousNode = i;
                i.order = nodeOrder++
                if (i.node.nodes) {
                    Fs.orderNodes(i.node.nodes, prefs)
                }
                let originalNode = nodes.find((ob) => ob.id === i.node.id);
                if (originalNode) {
                    originalNode.order = i.order;
                    originalNode.groupId = nodeGroup.id;
                }
            })
        })
        nodes.sort((a, b) => {
            return (a.order - b.order)
        })
    }

    static buildNodes(nodes, parent = false) {
        nodes.forEach((i, key) => {
            if (parent) {
                i.parent = parent
            }
            i.isDirectoryType = i.type !== 'file';
            i.createdAt = moment(i.createdOn);
            let tokens = [i.name, i.createdAt.format('MMMM Do YYYY, h:mm:ss a'), i.createdAt.format('DD/MM/YY HH:mm:ss'), i.createdBy]
            if (i.lastUpdatedOn) {
                i.lastUpdatedAt = moment(i.lastUpdatedOn);
                tokens.push(i.lastUpdatedAt.format('MMMM Do YYYY, h:mm:ss a'), i.lastUpdatedAt.format('DD/MM/YY HH:mm:ss'), i.lastUpdatedBy)
            }
            if (i.nodes) {
                i.nodes = Fs.buildNodes(i.nodes, i)
            }
            if (i.revisions) {
                i.revisions = Fs.buildNodes(i.revisions, i)
                i.revisions.sort((a, b) => (a.lastUpdatedAt ? a.lastUpdatedAt : a.createdAt) < (b.lastUpdatedAt ? b.lastUpdatedAt : b.createdAt));
            }
            if (i.tags) {
                tokens.push(...i.tags)
            }
            i.tokens = tokens.join('|').toLowerCase();
        });
        return nodes;
    }

    getNodeById(nodeId) {
        let searchNodes = (nodes, search, parent) => {
            for (let x in nodes) {
                let i = nodes[x]
                if (i.id === search) {
                    return i
                }
                if (i.nodes) {
                    let ret = searchNodes(i.nodes, search, i)
                    if (ret) {
                        return ret
                    }
                }
            }
            return false
        }
        return searchNodes(this.nodes, nodeId, null);
    }

    async createUploadIntent(files, targetId = null) {
        let id = uuid();
        const config = {files: files, targetId: targetId};
        let result = await Http.post(route('api.v2.filesystem.upload-intent', [this.id, id]), config);
        if (result.status !== 'ok') {
            // try again - then return the error
            result = await Http.post(route('api.v2.filesystem.upload-intent', [this.id, id]), config);
            if (result.status !== 'ok') return false
        }
        return await Http.get(route('api.v2.filesystem.upload-intent', [this.id, id]));
    }

    async confirmUploads(files, collisionStrategy = null) {
        const config = {uploads: files, collisionStrategy: collisionStrategy};
        let response = Model.make(await Http.put(route('api.v2.filesystem.confirm-uploads', [this.id]), config));
        if (response.status === 'failed') {
            throw new Error(response.message)
        }
        return true;
    }

    async updateNodeName(node, name) {
        const config = {nodes: [{id: node.id, name: name}]};
        node.name = name
        let response = await Http.put(route('api.v2.filesystem.nodes.update', [this.id]), config)
        let updates = await Fs.findNode(this.id, node.id)
        Object.assign(this.getNodeById(node.id), updates.nodes.find((n) => n.id === node.id))
        if (response.status === 'failed') {
            throw new Error(response.message)
        } else {
            this.reorderNodes(this.prefs);
        }
        return true
    }

    async promoteRevision(file, revision) {
        const config = {};
        let response = await Http.put(route('api.v2.filesystem.file.promote', [this.id, file.id, revision.id]), config)
        if (response.status === 'failed') {
            throw new Error(response.message)
        } else {
            let updates = await Fs.findNode(this.id, file.id)
            Object.assign(this.getNodeById(file.id), updates.nodes.find((n) => n.id === file.id))
            this.reorderNodes(this.prefs);
        }
        return true
    }

    async addTagToNodes(nodes, tag) {
        const config = {nodes: []};
        nodes.forEach((node) => {
            let tags = node.tags;
            if (!node.tags.includes(tag)) {
                tags.push(tag);
                config.nodes.push({id: node.id, tags: tags})
            }
        })
        await Http.put(route('api.v2.filesystem.nodes.update', [this.id]), config)
        let updatedFs = await Fs.find(this.id);
        nodes.forEach((node) => {
            let updatedNode = updatedFs.getNodeById(node.id)
            delete updatedNode.tags
            delete updatedNode.selectedGroups
            Object.assign(this.getNodeById(node.id), updatedNode)
        })
        this.tags = updatedFs.tags;
        this.reorderNodes(this.prefs);
        return true
    }

    async removeTagFromNodes(nodes, tag) {
        const config = {nodes: []};
        nodes.forEach((node) => {
            let tags = node.tags;
            if (node.tags.includes(tag)) {
                tags.splice(tags.indexOf(tag), 1);
                config.nodes.push({id: node.id, tags: tags})
            }
        })
        await Http.put(route('api.v2.filesystem.nodes.update', [this.id]), config)
        let updatedFs = await Fs.find(this.id);
        nodes.forEach((node) => {
            let updatedNode = updatedFs.getNodeById(node.id)
            delete updatedNode.tags
            delete updatedNode.selectedGroups
            Object.assign(this.getNodeById(node.id), updatedNode)
        })
        this.tags = updatedFs.tags;
        this.reorderNodes(this.prefs);
        return true
    }

    async createDirectory(name, target) {
        const config = {nodes: [{id: uuid(), name: name, targetId: target.isRoot ? null : target.id}]};
        let response = await Http.put(route('api.v2.filesystem.nodes.update', [this.id]), config)
        if (response.status === 'failed') {
            throw new Error(response.message)
        } else {
            let updatedFs = await Fs.find(this.id)
            this.nodes = updatedFs.nodes;
            this.reorderNodes(this.prefs);
        }
        return true
    }

    async deleteNodes(nodes) {
        const config = {
            nodes: nodes.map((i) => {
                return {id: i.id}
            })
        };
        await Http.delete(route('api.v2.filesystem.nodes.delete', [this.id]), config)
        let updatedFs = await Fs.find(this.id)
        this.nodes = updatedFs.nodes;
        this.reorderNodes(this.prefs);
        return true
    }

    async moveNodes(nodes, target) {
        const config = {
            nodes: nodes.map((i) => {
                return {id: i.id, targetId: target ? target.id : null}
            })
        };
        let response = await Http.put(route('api.v2.filesystem.nodes.update', [this.id]), config)
        if (response.status === 'failed') {
            throw new Error(response.message)
        } else {
            let updatedFs = await Fs.find(this.id)
            this.nodes = updatedFs.nodes;
            this.reorderNodes(this.prefs);
        }
        return true
    }

    async generateRotations(node) {
        await Http.post(route('api.v2.filesystem.rotations', [this.id, node.id]), {})
        let updates = await Fs.findNode(this.id, node.id)
        Object.assign(this.getNodeById(node.id), updates.nodes.find((n) => n.id === node.id))
        this.reorderNodes(this.prefs);
        return true
    }

}
